import { render, staticRenderFns } from "./myaccount.vue?vue&type=template&id=19804efc&"
import script from "./myaccount.vue?vue&type=script&lang=js&"
export * from "./myaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports